// removed by extract-text-webpack-plugin
module.exports = {"encoding-pane":"encoding-pane__encoding-pane","shelf-group":"encoding-pane__shelf-group"};


//////////////////
// WEBPACK FOOTER
// ./src/components/encoding-pane/encoding-pane.scss
// module id = 1215
// module chunks = 0